import React from 'react';
import { string, shape } from 'prop-types';

import { MoneyAmount } from '@andes/money-amount';

import { useProcessMoneyAmount, AMOUNT_PLACEHOLDER } from './hooks/useProcessMoneyAmount';

/**
 * @param {Object} props
 * @param {Object?} props.epigraph
 * @param {string?} props.className
 * @returns {React.ReactNode}
 */
export const Subtitle = ({ epigraph, className }) => {
  const { text: epigraphText, values = [], accessibility_text } = epigraph || {};

  const { before, after, fractionValue, cents, centsType, currency_id, size } = useProcessMoneyAmount({
    epigraphText,
    values,
  });

  if (epigraphText?.includes(AMOUNT_PLACEHOLDER)) {
    return (
      <div className={className}>
        {before}
        <MoneyAmount
          className="subtitle__money-amount"
          currencyId={currency_id}
          size={size}
          value={{
            cents,
            fraction: fractionValue,
          }}
          centsType={centsType}
        />
        {after}
      </div>
    );
  }

  return (
    epigraphText && (
      <div className={className} aria-label={accessibility_text}>
        {epigraphText}
      </div>
    )
  );
};

Subtitle.propTypes = {
  className: string,
  epigraph: shape({
    text: string,
  }),
};
